import type { ITheme } from '@inter-ikea-kompis/types';

export const getTheme = (theme: ITheme): ITheme => {
  const useProxy = ['ikea', 'www.ikea', 'planner.ikea'].every((key) => {
    return !window.location.host.startsWith(key);
  });

  if (useProxy) {
    theme.fontFace.sources.map((source) => {
      return Object.values(source.formats).map((format) => {
        format.url = new URL(format.url, 'https://kompis-proxy.azurewebsites.net').href;
        return source;
      });
    });
  }

  return theme;
};
